window.IMask = require('imask').default

let Module = {
    name: 'zip',
    misc: {
        zipCodesSimplified: require('../misc/zip-codes-simplified.json')
    },
    selectors: {
        input: '#zip'
    },
    maskObj: {},

    init: function (eventID = '') {
        let zipInput = null;
        if (eventID) {
            zipInput = $('[data-event-id="'+eventID+'"][data-name="zip"]');
        } else {
            zipInput = $(Module.selectors.input);
        }

        if (zipInput.length === 0) {
            return;
        }

        if (zipInput.data('country-code')) {
            Module.setMask(eventID, zipInput.data('country-code'));
        }

        $(document).on('countries'+eventID+':init', function (e) {
            Module.setMask(eventID, e.countryData.code);
        })

        $(document).on('countries'+eventID+':changed', function (e) {
            zipInput.val('');
            zipInput.data('value', '');
            Module.setMask(eventID, e.countryData.code);
        })

        // change country in the profile change subscription modal
        if (zipInput.data('subsc-id')) {
            $(document).on('ProfileCountrySelect_' + zipInput.data('subsc-id') + ':changed', function (e) {
                zipInput.val('');
                zipInput.data('value', '');
                Module.setMask(eventID, e.countryData.code);
            })
        }
    },

    setMask: function (eventID = '', countryCode) {
        let selector = Module.selectors.input;
        let objIndex = 'init';
        if (eventID) {
            selector = '[data-event-id="'+eventID+'"][data-name="zip"]';
            objIndex = eventID;
        }

        $(selector + ' + label').removeClass('notEmpty');

        if (Module.maskObj[objIndex]) this.maskObj[objIndex].destroy();
        let mask = Module.misc.zipCodesSimplified[countryCode];
        if (mask === undefined) {
            return;
        }

        if(mask === null) {
            let newName = $(selector).prop('name').replace(/zip/, 'zip_optional');
            $(selector).prop('name', newName);
            return;
        } else {
            let newName = $(selector).prop('name').replace(/zip_optional/, 'zip');
            $(selector).prop('name', newName);
        }

        let maskData = [];
        if(Array.isArray(mask)) {
            mask.forEach((maskItem) => {
                maskData.push({
                    mask: maskItem,
                });
            })
        } else {
            maskData = mask;
        }

        if (!Array.isArray(mask)) {
            $(Module.selectors.input + ' + label').addClass('notEmpty');
        }

        let maskOptions = {
            mask: maskData,
            overwrite: true,
            autofix: true,
            placeholderChar: '_',
            lazy: false,
        };
        
        let element = document.querySelector(selector);
        element.value = $(element).data().value ?? '';

        Module.maskObj[objIndex] = IMask(element, maskOptions);
        Module.maskObj[objIndex].updateValue('');
    },
}

module.exports = Module
